export class PatchShapeData {
    public readonly occupancy: boolean[][];
    public readonly polygon: PIXI.Polygon;

    constructor(pOccupancy: boolean[][], pPolygon: PIXI.Polygon) {
        this.occupancy = pOccupancy;
        this.polygon = pPolygon;
    }

    public rotatePolygon(pRotation: number): PIXI.Polygon {
        const width: number = this.occupancy[0].length;
        const height: number = this.occupancy.length;
        const rotated: PIXI.Polygon = new PIXI.Polygon();
        for (let i = 0; i < this.polygon.points.length; i += 2) {
            switch (pRotation) {
                case 0:
                    rotated.points.push(this.polygon.points[i]);
                    rotated.points.push(this.polygon.points[i + 1]);
                    break;
                case 1:
                    rotated.points.push(height - this.polygon.points[i + 1]);
                    rotated.points.push(this.polygon.points[i]);
                    break;
                case 2:
                    rotated.points.push(width - this.polygon.points[i]);
                    rotated.points.push(height - this.polygon.points[i + 1]);
                    break;
                case 3:
                    rotated.points.push(this.polygon.points[i + 1]);
                    rotated.points.push(width - this.polygon.points[i]);
                    break;
            }
        }
        return rotated;
    }

    public rotateOccupancy(pRotation: number): boolean[][] {
        const width: number = this.occupancy[0].length;
        const height: number = this.occupancy.length;
        const rotatedWidth: number = (pRotation === 0 || pRotation === 2) ? width : height;
        const rotatedHeight: number = (pRotation === 0 || pRotation === 2) ? height : width;

        const rotated: boolean[][] = new Array<boolean[]>(rotatedHeight);
        for (let y = 0; y < rotated.length; ++y) {
            rotated[y] = new Array<boolean>(rotatedWidth);
            for (let x = 0; x < rotated[y].length; ++x) {
                switch (pRotation) {
                    case 0:
                        rotated[y][x] = this.occupancy[y][x];
                        break;
                    case 1:
                        rotated[y][x] = this.occupancy[height - 1 - x][y];
                        break;
                    case 2:
                        rotated[y][x] = this.occupancy[height - 1 - y][width - 1 - x];
                        break;
                    case 3:
                        rotated[y][x] = this.occupancy[x][width - 1 - y];
                        break;
                }
            }
        }
        return rotated;
    }
}
